import * as React from 'react';
import { Doughnut, ChartComponentProps } from 'react-chartjs-2';

// Component
export interface IProps extends ChartComponentProps {

}

function BarChart(props: IProps) {
    return <Doughnut {...props} />;
}

export default BarChart;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Chart/DoughnutChart.tsx